var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubrir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 15.5833L12.5947 4.42978L4.42978 12.5947L15.5833 15.5833ZM0.292893 1.70711L8.51226 9.92648L9.92648 8.51226L1.70711 0.292893L0.292893 1.70711Z",
    fill: "#ECEDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4167 15.5833L24.4053 4.42978L32.5702 12.5947L21.4167 15.5833ZM36.7071 1.70711L28.4877 9.92648L27.0735 8.51226L35.2929 0.292893L36.7071 1.70711Z",
    fill: "#ECEDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 21.4167L12.5947 32.5702L4.42978 24.4053L15.5833 21.4167ZM0.292893 35.2929L8.51226 27.0735L9.92648 28.4877L1.70711 36.7071L0.292893 35.2929Z",
    fill: "#ECEDEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4167 21.4167L24.4053 32.5702L32.5702 24.4053L21.4167 21.4167ZM36.7071 35.2929L28.4877 27.0735L27.0735 28.4877L35.2929 36.7071L36.7071 35.2929Z",
    fill: "#ECEDEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubrir);
export default __webpack_public_path__ + "static/media/cubrir.e073cf91f01f1144a49204b991fe8465.svg";
export { ForwardRef as ReactComponent };